import React, { ReactElement } from "react";

interface Props {
  /**
   * Shown when the pocket is expanded, to the left of the preview.
   */
  children?: React.ReactNode;
  onMouseLeave?: () => void;
}

function DotPocket({ children, onMouseLeave }: Props): ReactElement {
  return (
    <div
      className="rounded-full py-0.5 px-1 shadow-md bg-white text-black inline-flex gap-1 place-items-center"
      onMouseOut={() => onMouseLeave?.()}
      onBlur={() => {
        // TODO(a11y): is this necessary?
      }}
    >
      {children}
    </div>
  );
}

export default DotPocket;
